import axios from '@/libs/api.request'
// 用户基本信息
export const infoQueryDetail = data => {
  return axios.request({
    url: '/info/query/detail',
    data,
    method: 'POST'
  })
}
// 保存头像
export const saveModifyHead = data => {
  return axios.request({
    url: '/info/modify/head',
    data,
    method: 'POST'
  })
}
// 上传CV
export const saveModifyCV = data => {
  return axios.request({
    url: '/info/modify/upload/cv',
    data,
    method: 'POST'
  })
}
// 上传成绩单
export const saveModifyReportCard = data => {
  return axios.request({
    url: '/info/modify/upload/report/card',
    data,
    method: 'POST'
  })
}
// 获取套餐信息
export const getPackagesInfo = data => {
  return axios.request({
    url: '/info/query/packages',
    data,
    method: 'POST'
  })
}

// 查询教育背景
export const infoQueryEducational = data => {
  return axios.request({
    url: '/info/query/educational',
    data,
    method: 'POST'
  })
}

// 查询成绩信息
export const infoQueryScore = data => {
  return axios.request({
    url: '/info/query/score',
    data,
    method: 'POST'
  })
}

// 查询个人经验（补充信息）
export const infoQueryPersonalexp = data => {
  return axios.request({
    url: '/info/query/personalexp',
    data,
    method: 'POST'
  })
}

// 查询申请意向
export const infoQueryApplypurpose = data => {
  return axios.request({
    url: '/info/query/applypurpose',
    data,
    method: 'POST'
  })
}

// 查询项目信息
export const infoQueryItem = data => {
  return axios.request({
    url: '/info/query/item',
    data,
    method: 'POST'
  })
}

// 查询研究方向
export const infoQueryDirection = data => {
  return axios.request({
    url: '/info/query/direction',
    data,
    method: 'POST'
  })
}

// 查询科研经历
export const infoQueryScientific = data => {
  return axios.request({
    url: '/info/query/scientific',
    data,
    method: 'POST'
  })
}

// 查询实习经历
export const infoQueryInternship = data => {
  return axios.request({
    url: '/info/query/internship',
    data,
    method: 'POST'
  })
}

// 查询课外活动
export const infoQueryActivities = data => {
  return axios.request({
    url: '/info/query/activities',
    data,
    method: 'POST'
  })
}

// 查询家庭信息
export const infoQueryFamily = data => {
  return axios.request({
    url: '/info/query/family',
    data,
    method: 'POST'
  })
}

// 修改教育信息
export const infoModifyEducational = data => {
  return axios.request({
    url: '/info/modify/educational',
    data,
    method: 'POST'
  })
}

// 修改成绩信息
export const infoModifyScore = data => {
  return axios.request({
    url: '/info/modify/score',
    data,
    method: 'POST'
  })
}
// 修改补充信息
export const infoModifyPersonalexp = data => {
  return axios.request({
    url: '/info/modify/personalexp',
    data,
    method: 'POST'
  })
}
// 修改申请意向
export const infoModifyApplypurpose = data => {
  return axios.request({
    url: '/info/modify/applypurpose',
    data,
    method: 'POST'
  })
}
// 修改项目信息
export const infoModifyItem = data => {
  return axios.request({
    url: '/info/modify/item',
    data,
    method: 'POST'
  })
}
// 修改研究方向
export const infoModifyResearch = data => {
  return axios.request({
    url: '/info/modify/research',
    data,
    method: 'POST'
  })
}
// 修改科研经历
export const infoModifyScientific = data => {
  return axios.request({
    url: '/info/modify/scientific',
    data,
    method: 'POST'
  })
}
// 修改实习经历
export const infoModifyInternship = data => {
  return axios.request({
    url: '/info/modify/internship',
    data,
    method: 'POST'
  })
}
// 修改课外活动
export const infoModifyActivities = data => {
  return axios.request({
    url: '/info/modify/activities',
    data,
    method: 'POST'
  })
}
// 修改家庭信息
export const infoModifyFamily = data => {
  return axios.request({
    url: '/info/modify/family',
    data,
    method: 'POST'
  })
}
// 系统内部修改密码
export const subModifyPwd = data => {
  return axios.request({
    url: '/password',
    data,
    method: 'POST'
  })
}
// 获取腾讯视频是否展示
export const getTencentVideoShow = data => {
  return axios.request({
    url: '/info/query/tencent/video',
    data,
    method: 'POST'
  })
}
// 查看专家信息
export const getInfoQueryTeam = data => {
  return axios.request({
    url: '/info/query/team',
    data,
    method: 'POST'
  })
}
// 获取导师辅导非申请季的下拉框信息
export const getInfoApplicationSelect = data => {
  return axios.request({
    url: '/appointment/course/list',
    data,
    method: 'POST'
  })
}
// 上传信息搜集表
export const getInfoApplicationFile = data => {
  return axios.request({
    url: '/info/query/expert/file',
    data,
    method: 'POST'
  })
}
// PS信息搜集表
export const infoUploadPS = data => {
  return axios.request({
    url: '/info/modify/upload/expert/ps',
    data: data,
    method: 'POST'
  })
}
// 简历信息搜集表
export const infoUploadCV = data => {
  return axios.request({
    url: '/info/modify/upload/expert/cv',
    data: data,
    method: 'POST'
  })
}
// 推荐信信息搜集表
export const infoUploadRL = data => {
  return axios.request({
    url: '/info/modify/upload/expert/rl',
    data: data,
    method: 'POST'
  })
}
